import z from 'zod'

const UnreadActivitiesCountSchema = z.object({
  entityID: z.string(),
  unreadCount: z.number().default(0),
  activityID: z
    .string()
    .nullish()
    .transform((data) => data ?? null),
})

export const UnreadActivitiesCountListSchema = z.record(z.string(), UnreadActivitiesCountSchema)

export type UnreadActivitiesCount = z.infer<typeof UnreadActivitiesCountSchema>
export type UnreadActivitiesCountList = z.infer<typeof UnreadActivitiesCountListSchema>
